import type { FaireProductEntity } from "../../entity_types/product";

export const p_g2z57gj7tx: FaireProductEntity = {
  token: "p_g2z57gj7tx",
  type: "product",
  name: "Game Night! Double Deck Playing Cards, Floral",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/cc93aeb5247fd6bb14e12daf88ffe3f7669f2b3bcb02ec634bd5b1a4ec608668.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ee3d7008f0d5eb3de648bf783e448f0a9a051dcade41d041a97b01bde41d37d3.jpeg",
    "https://cdn.faire.com/fastly/8e2deec4db96114f99398012a2b79b7f0fe4531883712cd83b86b191d5b8694b.jpeg",
    "https://cdn.faire.com/fastly/8c8abb925e20b2ba184b1b6df2a7cf341a07f0a79ef64c14e7345e77aee8c4ed.jpeg",
    "https://cdn.faire.com/fastly/0cafc149c7b2b795fe6bcdad916034d0614cbb21bc754d8a6c2dd930cf0ecef0.jpeg"
  ],
  priceDollars: 9,
  description: "No home is complete without a nice set of playing cards. This ban.do playing card set includes two full decks, each featuring bright, colorful designs on every card. Whether you’re hosting a game night or just want to show off your style, these decks bring a cheerful twist to every hand.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n• Set of 2 full decks of standard playing cards\n• Each deck features unique, colorful designs\n• Made of durable, high-quality cardstock\n• Perfect for game nights, travel, or décor\n• Designed in ban.do’s signature fun and optimistic style\n\n𝐈𝐝𝐞𝐚𝐥 𝐅𝐨𝐫:\n• Gift shops and home décor boutiques\n• Lifestyle retailers and game collections\n• Card players, party hosts, and collectors\n• Wholesale buyers seeking colorful, design-forward games",
  tags: [],
  msrpDollars: 18.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:39.963Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
